export default "__VITE_ASSET__CK7wu9Bc__"